export class UserDashboardSettings {
	useChannelColors: boolean;
}
